"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomIDView = exports.QRCodeView = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_qr_code_1 = __importDefault(require("react-qr-code"));
const base_ui_buttons_button_1 = require("@unboared/base-ui.buttons.button");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const checkRoom = (roomID) => roomID === '' || roomID === '0' || roomID === 0;
/**
 * Display the QRCode related to a room identifier.
 * @param {number} roomID - The identifier of the room.
 *
 */
const QRCodeView = ({ roomID, url, size = 150 }) => {
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const qrStyle = {
        backgroundColor: 'white',
        padding: normalize(size / 10),
    };
    if (checkRoom(roomID)) {
        return null; //<GridLoader color={"#ffffff"} loading={true} size={80} css={{ width: 270 }} />
    }
    return (react_1.default.createElement(react_native_1.View, { style: qrStyle },
        react_1.default.createElement(react_qr_code_1.default, { size: normalize(size), value: url })));
};
exports.QRCodeView = QRCodeView;
/**
 * Display the room identifier in a box.
 * @param {int} roomID - The identifier of the room.
 *
 */
const RoomIDView = ({ roomID, url, test, size, }) => {
    const buttonTitle = checkRoom(roomID) ? '...' : '' + roomID;
    return (react_1.default.createElement(base_ui_buttons_button_1.Button, { text: buttonTitle, size: size, textPreset: 'medium', onPress: () => {
            if (test) {
                if (react_native_1.Platform.OS === 'web') {
                    window.open(url, '_blank');
                }
                else {
                    console.log('This function is disabled for native apps');
                }
            }
        } }));
};
exports.RoomIDView = RoomIDView;
//# sourceMappingURL=connexion_view.js.map